import { Text } from '../../../atoms'
import { TextTypes } from '../../../../types'
import React from 'react'

interface Props {
    children: React.ReactNode
}

export const SubNavigationSubHeading = ({ children }: Props) => {
    return (
        <li
            className="main-navigation__subnavigation-sub-heading whitespace-nowrap min-w-full flex w-full text-left pt-4 pb-1 px-4 text-text-primary"
            role="presentation"
        >
            <Text type={TextTypes.SMALL_TEXT}>{children}</Text>
        </li>
    )
}

